import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import PageHero from "@/components/PageHero";
import { Container, SectionHeading, GoldButton, OutlineButton } from "@/components/shared";
import ListingCard from "@/components/ListingCard";

const IMG = "https://images.unsplash.com/photo-1717174704421-0ce3dc8a7225?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function Massachusetts() {
  const [listings, setListings] = useState([]);
  useEffect(() => {
    api.get("/listings", { params: { shore: "massachusetts" } }).then((r) => setListings(r.data));
  }, []);

  return (
    <div>
      <PageHero
        kicker="The daughter city"
        title="Boston, Massachusetts"
        intro="Named on 7 September 1630 by Puritan settlers of the Massachusetts Bay Colony, and grown from a small peninsula settlement into one of the great harbour cities of the Atlantic — still carrying the old Lincolnshire name."
      >
        <div className="flex flex-wrap gap-3">
          <GoldButton as="link" to="/visit/massachusetts">Plan a visit</GoldButton>
          <OutlineButton as="link" to="/lincolnshire" className="px-6 py-3">← See the mother town</OutlineButton>
        </div>
      </PageHero>

      <section className="py-16 sm:py-20">
        <Container>
          <div className="grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-6 lg:order-2">
              <img src={IMG} alt="Boston Harbour, Massachusetts" className="w-full h-[420px] object-cover border border-[#D6D3CB]" />
            </div>
            <div className="lg:col-span-6 lg:order-1">
              <SectionHeading title="A harbour that kept the name" />
              <div className="space-y-4 font-sans text-base text-[#1B2430] leading-relaxed mt-6">
                <p>
                  The peninsula the settlers reached was called Shawmut by the Massachusett people,
                  whose land it was. The newcomers first named their settlement Trimountaine for its
                  three hills, then renamed it Boston in honour of the Lincolnshire town so many had
                  left.
                </p>
                <p>
                  From that small beginning the city grew — a port, a place of argument and printing,
                  and in time a centre of American life. Its Common, its North End, and its working
                  waterfront still shape the daughter city today.
                </p>
                <p>
                  Makers here keep their own trades, from copper-raising to clay, and many keep an
                  eye on the mother town across the water.
                </p>
              </div>
            </div>
          </div>
        </Container>
      </section>

      <section className="pb-16 sm:pb-24">
        <Container>
          <div className="flex items-end justify-between gap-4 mb-8">
            <SectionHeading kicker="Made here" title="Makers on the Massachusetts shore" />
            <OutlineButton as="link" to="/made" className="whitespace-nowrap">All makers <ArrowRight size={15} className="ml-2" /></OutlineButton>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {listings.map((l) => (
              <ListingCard key={l.id} listing={l} />
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}
